module.exports = require('./helpers/bundle-url').getBundleURL('filTu') + "logo-dark.eefe0b7f.svg";